import { ArrowUpRight } from "lucide-react";
import { MEDIA, BOOKING } from "../i18n";
import { openCalendly } from "../utils/calendly";
import Reveal from "./Reveal";

export default function Process({ t }) {
  const handleDiscovery = () => openCalendly(BOOKING.calendlyDiscovery);
  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-28 md:py-40 bg-[#F5EFE6]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <Reveal>
            <span className="overline">{t.process.overline}</span>
          </Reveal>
          <Reveal delay={120}>
            <h2
              className="font-serif text-4xl md:text-5xl lg:text-6xl mt-5 leading-[1.05] text-[#3E362E]"
              data-testid="process-title"
            >
              {t.process.title}
            </h2>
          </Reveal>

          <Reveal delay={220}>
            <div className="mt-10 img-frame aspect-[4/5] max-w-md">
              <img src={MEDIA.pathOpen} alt="Open path leading to the horizon" />
            </div>
          </Reveal>

          <Reveal delay={340}>
            <div className="mt-6 inline-flex flex-col items-start gap-4 border-l-2 border-[#1A9BC1] pl-6 max-w-md">
              <span className="font-chinese text-7xl text-[#1A9BC1] leading-none">
                源
              </span>
              <span className="overline">Yuan · Origin</span>
              <p className="text-[#5E554C] text-base font-light italic leading-relaxed mt-2">
                "El subconsciente tiene todas las respuestas. Solo hay que saber preguntar."
              </p>
              <span className="text-xs tracking-widest uppercase text-[#8D7B68]">
                — Dolores Cannon
              </span>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:pl-10">
          <div className="flex flex-col">
            {t.process.steps.map((step, i) => (
              <Reveal key={step.n} delay={i * 150}>
                <div
                  className="process-step grid grid-cols-12 gap-6"
                  data-testid={`process-step-${i}`}
                >
                  <div className="col-span-2">
                    <span className="section-number text-xl">{step.n}</span>
                  </div>
                  <div className="col-span-10">
                    <h3 className="font-serif text-2xl md:text-3xl text-[#3E362E] mb-2">
                      {step.title}
                    </h3>
                    <p className="text-[#5E554C] text-base font-light leading-relaxed max-w-xl">
                      {step.desc}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={600}>
            <button
              type="button"
              onClick={handleDiscovery}
              className="btn-primary mt-12"
              data-testid="process-cta"
            >
              {t.hero.primaryCta}
              <ArrowUpRight size={16} />
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
